import React, { PureComponent, ReactNode } from 'react'
import { Button, Page, Title, ValidatedInput } from '../../components'
import { DispatchProp } from 'react-redux'
import { connectRedux } from '../../helpers/connectRedux'

import { RouteComponentProps, withRouter } from '../../helpers/withRouter'
import { IUser } from '../../models'
import { LiteralsService } from '../../services'
import { setNewPasswordRequiredPasswordAction, setNewPasswordRequiredSavePasswordAction } from '../../store/actions'
import { isPasswordValid } from '../../helpers'
import StyledArticle from './styles'
import { IStoreState } from '../../store/states'
import { appsLogosSelected, appsStyleSelected } from '../../helpers/app'
import { images } from '../../images'
import { urls } from '../../routing'
import { AnyAction } from 'redux'

interface IProps extends DispatchProp<AnyAction>, RouteComponentProps {
  user: IUser
  password: string
  isSigningIn: boolean
}

interface IState {
  repeatPassword: string
}
class NewPasswordRequired extends PureComponent<IProps, IState> {

  constructor(props: IProps) {
    super(props)

    this.state = {
      repeatPassword: ''
    }
  }

  private get passwordAlert(): ReactNode {
    const { password } = this.props

    return (
      password !== '' &&
      !isPasswordValid(password) && (
        <div className='error-container'>
          <label className='error-message'>
            { LiteralsService.get('validPassword', true) }
          </label>
        </div>
      )
    )
  }

  private get buttonDisabled(): boolean {
    const { password, isSigningIn } = this.props
    return !isPasswordValid(password) ||
      password !== this.state.repeatPassword ||
      isSigningIn
  }

  public render(): ReactNode {
    const { password, history } = this.props
    const { repeatPassword } = this.state

    return (
      <Page className={ `${appsStyleSelected?.style}` }>
        <StyledArticle>
          <div className='form-wrapper'>
            <header>
              <img  className={ appsLogosSelected?.classRounded }
                    src={ appsLogosSelected?.logoRounded }
                    alt={ appsLogosSelected?.alt } />
            </header>
            <Title text={ LiteralsService.get('newPassword', true) } />
            <div className='new-password-wrapper'>
              <ValidatedInput
                name="password"
                label={ LiteralsService.get('password', true) }
                value={ password }
                onChange={ this.onPasswordChange }
                error={ !isPasswordValid(password) }
                isPassword
              />
              { this.passwordAlert } 
              <ValidatedInput
                name="repeatPassword"
                label={ LiteralsService.get('repeatPassword', true) }
                value={ repeatPassword }
                onChange={ this.onRepeatPasswordChange }
                error={ !isPasswordValid(repeatPassword) || password !== repeatPassword }
                isPassword
              />
            </div>
            <section className='actions'>
              <Button
                title={ LiteralsService.get('continue') }
                onPress={ this.onSaveNewPassword }
                filled
                upper
                isDisabled={ this.buttonDisabled }
              />
              <section className='backButton' onClick={ () => history.push(urls.signIn) }>
                <img src={ images.arrowLeft } alt='back icon' />
                <span>{ LiteralsService.get('goBack', true) }</span>
              </section>
            </section>
          </div>
        </StyledArticle>
      </Page>
    )
  }

  private onPasswordChange = (password: string) => {
    const { dispatch } = this.props
    dispatch(setNewPasswordRequiredPasswordAction(password))
  }

  private onRepeatPasswordChange = (repeatPassword: string) => {
    this.setState({ repeatPassword })
  }

  private onSaveNewPassword = () => {
    const { dispatch } = this.props
    dispatch(setNewPasswordRequiredSavePasswordAction())
  }

}

const mapStateToProps = ({ newPasswordRequired, signIn }: IStoreState) => ({
  user: newPasswordRequired.user,
  password: newPasswordRequired.password,
  isSigningIn: signIn.isSigningIn
})

export default withRouter(connectRedux(mapStateToProps, NewPasswordRequired))
